import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Applicant } from '@app/models/recruiting/applicant.model';
import { HiringAccessLevelLabelOptions } from '@app/types/translatables/applicant-tracker/hiring-access-level-label.options';
import { Answer } from '@models/recruiting/answer.model';

@Component({
    templateUrl: './questions.template.html',
    styleUrls: ['./questions.style.scss'],
})
export class QuestionsComponent implements OnInit {
    applicant: Applicant;
    isLoading = false;
    showAutoArchivedBanner = false;
    additionalApplicantQuestions: Answer[] = [];
    autoArchivingQuestions: Answer[] = [];
    HiringAccessLevelLabelOptions = HiringAccessLevelLabelOptions;

    constructor(
        private route: ActivatedRoute,
        private sanitizer: DomSanitizer
    ) {
        this.isLoading = true;
    }

    async ngOnInit(): Promise<void> {
        this.applicant = this.route.parent.snapshot.data.models.get('applicant');

        const [answers] = await Answer.where('applicantId', this.applicant.id).with('questionV2').all();

        this.additionalApplicantQuestions = answers.filter((a) => !a.questionV2.isAutoArchive);
        this.autoArchivingQuestions = answers.filter((a) => a.questionV2.isAutoArchive);

        this.showAutoArchivedBanner = this.autoArchivingQuestions.some((answer) => answer.answer === 'no');

        this.isLoading = false;
    }

    isFieldUrl(body: string): boolean {
        const linkExpression =
            '(https?://(?:www.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9].[^s]{2,}|www.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9].[^s]{2,}|https?://(?:www.|(?!www))[a-zA-Z0-9]+.[^s]{2,}|www.[a-zA-Z0-9]+.[^s]{2,})';
        const regex = new RegExp(linkExpression);
        return regex.test(body);
    }

    sanitizeUrl(body: string): SafeHtml {
        return this.sanitizer.bypassSecurityTrustUrl(body);
    }
}
